import { MasterDetailListEntry } from "@sdbn/common";

export class Smartphone implements MasterDetailListEntry {

    id: number;
    nbr: string;

    constructor(smartphone: any) {
        this.id = smartphone.id;
        this.nbr = smartphone.nbr;
    }

    public get listTitle(): string {
        return '#' + this.nbr;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }

}
